import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import Accordion from "../../Accordion/Accordion.js";
import data from "../../Data/clinicalTrialsData.json";

export default function ClinicalTrials() {
  return (
    <section className="contacts сlinicalTrials">
      <Breadcrumbs />
      <h1 className="contacts__title history__title licenses__title сlinicalTrials__title">
        Клинические испытания лекарственных средств
      </h1>

      <Accordion data={data} />
    </section>
  );
}
